// extracted by mini-css-extract-plugin
export default {"page":"CDeQM","header":"vi1uh","formInner":"XpeIz","inner":"Bgjjw","form":"fcr4h","actions":"B0e_Q","action":"aYww6"};